import styled from '@emotion/styled';
import { ClassAttributes, createElement, ReactElement } from 'react';

import { SPACING_REGULAR, SPACING_UNIT } from '../../../constant/spacing';
import { flexibleLayoutContainer } from '../../../styleUtility/flexibleLayout';
import Spinner from '../Spinner';
import _EmptyState from './EmptyState';
import { Props as ItemProps } from './OfferListItem';

interface Props {
  loading: boolean;
  className?: string;
  children: ReactElement<ItemProps>[];
}

const OfferList = ({ loading, className, children }: ClassAttributes<HTMLElement> & Props) => {
  if (!loading && children.length === 0) {
    return <EmptyState className={className} />;
  }

  return (
    <Root className={className}>
      {children}

      {loading && <Spinner className={className} />}
    </Root>
  );
};

const Root = styled('div')(
  flexibleLayoutContainer({
    direction: 'column',
    alignItems: 'stretch',
    justifyContent: 'center',
  }),
  {
    '& > *': {
      marginBottom: SPACING_REGULAR,
      ':last-child': {
        marginBottom: 0,
      },
    },
  },
);

const EmptyState = styled(_EmptyState)({ paddingTop: SPACING_UNIT * 13 });

export default OfferList;
